var _style, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPinRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "24px",
    height: "25px",
    viewBox: "0 0 24 25",
    style: {
      enableBackground: "new 0 0 24 25"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#AF1C2D;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M11.8,3.1C8,3.1,5,6.1,5,9.8c0,5.6,6.3,10.9,6.6,11.2c0.1,0,0.1,0.1,0.2,0.1c0.1,0,0.1,0,0.2-0.1 c0.3-0.2,6.6-5.5,6.6-11.2C18.5,6.1,15.5,3.1,11.8,3.1z M11.8,20.4c-1-0.9-6.2-5.8-6.2-10.6c0-3.4,2.8-6.2,6.2-6.2 c3.4,0,6.2,2.8,6.2,6.2C17.9,14.7,12.8,19.5,11.8,20.4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M11.8,6.4c-1.9,0-3.4,1.5-3.4,3.4c0,1.9,1.5,3.4,3.4,3.4c1.9,0,3.4-1.5,3.4-3.4C15.1,7.9,13.6,6.4,11.8,6.4z  M11.8,12.6c-1.6,0-2.8-1.3-2.8-2.8S10.2,7,11.8,7s2.8,1.3,2.8,2.8S13.3,12.6,11.8,12.6z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinRed);
export default __webpack_public_path__ + "static/media/pin-red.2e33126d88abdfa5a0c4733e174283e0.svg";
export { ForwardRef as ReactComponent };